export const FETCH_ASSETLIST_BEGIN="FETCH_ASSETLIST_BEGIN";
export const FETCH_ASSETLIST_SUCCESS="FETCH_ASSETLIST_SUCCESS";
export const FETCH_ASSETLIST_FAILURE="FETCH_ASSETLIST_FAILURE";

export const FETCH_ASSETLIST_BEGIN_DDL="FETCH_ASSETLIST_BEGIN_DDL";
export const FETCH_ASSETLIST_SUCCESS_DDL="FETCH_ASSETLIST_SUCCESS_DDL";
export const FETCH_ASSETLIST_FAILURE_DDL="FETCH_ASSETLIST_FAILURE_DDL";

export const FETCH_ASSET_BEGIN="FETCH_ASSET_BEGIN";
export const FETCH_ASSET_SUCCESS="FETCH_ASSET_SUCCESS";
export const FETCH_ASSET_FAILURE="FETCH_ASSET_FAILURE";


export const FETCH_ASSET_CURRENCYTYPE_BEGIN="FETCH_ASSET_CURRENCYTYPE_BEGIN";
export const FETCH_ASSET_CURRENCYTYPE_SUCCESS="FETCH_ASSET_CURRENCYTYPE_SUCCESS";
export const FETCH_ASSET_CURRENCYTYPE_FAILURE="FETCH_ASSET_CURRENCYTYPE_FAILURE";


